import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {persistor, store} from './Redux/store'
import {PersistGate} from 'redux-persist/integration/react'
import Modal from 'react-modal';


import App from './App';

Modal.setAppElement('#root');

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
, document.getElementById('root'));
